<div class="row mice-enquiry" [@animate]="{value:'*',params:{delay:'5ms',x:'-25px'}}">
  <div class="col-md-4 pd-0 d-none d-md-block">
    <img class="mice-enquiry__img" src="../../../assets/img/career (1).jpg" loading="lazy" alt="career"> 
  </div>
  <div class="col-md-8 mice-enquiry__wrapper">
    <h2 class="mice-enquiry__title">{{title}}</h2>

    <button aria-label="Close" type="button" mat-dialog-close class="btn btn-light map-close btn-close"></button>

    <div class="scroll" [@animate]="{value:'*',params:{delay:'5ms',x:'-25px'}}">
      <form class="mice-enquiry__form needs-validation" [formGroup]="CareerForm" (submit)="onSubmit()">
        <div class="row ">
          <div class="col-md-6">
            <div class="form-floating">
              <input type="text" class="form-control" formControlName="firstname" placeholder="Firstname">
              <label for="firstname">First Name*</label>
              <div *ngIf="CareerForm.controls['firstname'].invalid && CareerForm.controls['firstname'].touched">
                <span *ngIf="checkError('firstname', 'required')">*Please enter your first Name.</span>
              </div>

              <!-- <div *ngIf="CareerForm.get('firstname').invalid && CareerForm.get('firstname').touched" class="text-danger">
                First Name is required
              </div> -->
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-floating">
              <input type="text" class="form-control" formControlName="lastname" placeholder="Lastname">
              <label for="lastname">Last Name*</label>
              <div *ngIf="CareerForm.get('lastname').invalid && CareerForm.get('lastname').touched" class="text-danger">
                Please enter your Last Name.
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-floating">
              <input type="email" class="form-control" formControlName="email" placeholder="Email address">
              <label for="email">Email address*</label>
              <div *ngIf="CareerForm.controls['email'].invalid && CareerForm.controls['email'].touched">
                <span *ngIf="checkError('email', 'required')">*Please enter email address.</span>
                <span *ngIf="checkError('email', 'email')"></span>
                <span *ngIf="checkError('email', 'pattern')">*Please enter a valid email address.</span>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-floating">
              <input type="text" class="form-control" formControlName="mobileNo" placeholder="Phone Number"
                maxlength="10">
              <label for="contact">Phone Number*</label>
              <div *ngIf="CareerForm.controls['mobileNo'].invalid && CareerForm.controls['mobileNo'].touched">
                <span *ngIf="checkError('mobileNo', 'required')">*Please enter a Phone Number..</span>
                <span *ngIf="checkError('mobileNo', 'maxlength')"></span>
                <span *ngIf="checkError('mobileNo', 'pattern')">Please enter valid number.</span>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-floating frm-date">
              <input type="date" class="form-control" formControlName="bod" placeholder="">
              <label class="frm-text" for="ctc">Date of Birth</label>
              <div *ngIf="CareerForm.controls['bod'].invalid && CareerForm.controls['bod'].touched">

                <!-- <span *ngIf="checkError('dateOfTravel','required')">Please include the date of travel in the required field.</span> -->
                <span *ngIf="checkError('bod','invalidDate')">Please select correct dob.</span>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-floating">
              <input type="text" class="form-control" formControlName="ctc" placeholder="CTC">
              <label for="ctc">CTC</label>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-floating">
              <input type="text" class="form-control" formControlName="location" placeholder="Location">
              <label for="location">Location</label>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-floating">
              <input type="text" class="form-control" formControlName="presentEmployer" placeholder="Present Employer">
              <label for="presentEmployer">Present Employer</label>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-floating">
              <input type="text" class="form-control" formControlName="applyFor" placeholder="Apply For">
              <label for="applyFor">Apply For Which Position*</label>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-floating frm-date">
              <input type="date" class="form-control" formControlName="scheduleDate" placeholder="Schedule Date">
              <label class="frm-text" for="scheduleDate">Choose Interview Date</label>
              <div *ngIf="CareerForm.controls['scheduleDate'].invalid && CareerForm.controls['scheduleDate'].touched">

                <!-- <span *ngIf="checkError('dateOfTravel','required')">Please include the date of travel in the required field.</span> -->
                <span *ngIf="checkError('scheduleDate','invalidDate')">Please select interview date.</span>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-floating">
              <input type="text" class="form-control" formControlName="noticePeriod" placeholder="Notice Period">

              <label for="noticePeriod">Notice Period </label>

              <div *ngIf="CareerForm.get('noticePeriod').invalid && CareerForm.get('noticePeriod').touched"
                class="text-danger">
                Notice Period is required
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group no-height">
              <span class="frm-text">Upload Resume*: </span>
              <input type="file" class="fileupload" name="resume" (change)="onFileChange($event)">
              <div *ngIf="CareerForm.get('resume').invalid && CareerForm.get('resume').touched" >
                Please upload a resume with the extentsion of 'pdf', 'doc', 'docx'.
              </div>
            </div>
          </div>
          <!-- <p class="error">{{errorMessage}}</p> -->
        </div>
        <div class="row">
          <div class="col-12 d-flex justify-content-start fix-btn">
            <button class="btn btn-primary btn-lg read-morebtn" type="submit"
              [disabled]="!CareerForm.valid || disableSubmitbtn">Submit</button>
          </div>
        </div>
      </form>
      <div class="thank-you d-none" *ngIf="thankYouMessageVisible"
        [@animate]="{value:'*',params:{delay:'5ms',x:'-25px'}}">
        <div>
          <img src="../../../assets/img/thank-you.png" alt="thank you">
          <h3 class="thank-you__title">Thank you for submitting your Application Form!</h3>
          <p class="thank-you__msg">We have received your Application Form and our team is actively reviewing it.</p>
          <p> We value your time and will respond to your Form as quickly as possible. </p>

          <button type="submit" class="btn btn-primary btn-lg read-morebtn" (click)="closeDialog()"><i
              class="fa fa-arrow-alt-circle-left"></i>Back to Site</button>
        </div>
      </div>

    </div>
  </div>
</div>